module.exports = __webpack_public_path__ + "static/media/Magmizer.490454a5.png";